module.exports = __webpack_public_path__ + "teqbahn-assets/media/6.263c0e33.jpg";